import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UsuarioService } from '../../../services/usuario.service';


@Component({
    selector: 'app-produtos-desconto-personalizado-dialog',
    templateUrl: './produtos-desconto-personalizado-dialog.html',
    styleUrls: ['./produtos-desconto-personalizado-dialog.scss', '../../../styles/estilo.padrao.scss']
})

export class ProdutosDescontoPersonalizadoDialog implements OnInit {
    uid;
    produtoDescontoForm: FormGroup;
    auxObservableNomesProdutos;
    produtos;
    bCaracterEspecial: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        private toastr: ToastrService,
        private dialogRef: MatDialogRef<ProdutosDescontoPersonalizadoDialog>,
        private usuarioService: UsuarioService,
        @Inject(MAT_DIALOG_DATA) public data: { idGrupo: string, nome: string, quantidadeMinima: number, porcentagemDesconto: number, produtos: any }
    ) {
        this.uid = localStorage.getItem('uid');
    }

    ngOnInit(): void {
        this.produtoDescontoForm = this.formBuilder.group({
            idGrupo: ['', [Validators.required]],
            nome: ['', [Validators.required]],
            quantidadeMinima: [1, [Validators.required, Validators.min(1)]],
            // porcentagemDesconto: [0, [Validators.required, Validators.min(1), Validators.max(920)]],
            //50%
            porcentagemDesconto: [0, [Validators.required, Validators.min(1), Validators.max(5000)]],
            produtos: ['', [Validators.required]],
            produtosString: ['', null],
        });
    }

    adicionarPromocao() {
        if (this.produtoDescontoForm.valid) {
            this.dialogRef.close({ IDGrupoDesconto: this.f.idGrupo.value, Nome: this.f.nome.value, QuantidadeMinima: this.f.quantidadeMinima.value, PorcentagemDesconto: this.f.porcentagemDesconto.value, Produtos: this.f.produtos.value, ProdutosString: this.f.produtosString.value });

        } else {
            this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
            this.produtoDescontoForm.markAllAsTouched();
        }
    }

    detalharProduto(produto) {
        if (produto) {
            this.produtoDescontoForm.get('idGrupo').patchValue(produto.ID);
            this.produtoDescontoForm.get('nome').patchValue(produto.Nome);
            this.produtoDescontoForm.get('quantidadeMinima').patchValue(produto.QuantidadeMinima);
            this.produtoDescontoForm.get('porcentagemDesconto').patchValue(0);
            this.produtoDescontoForm.get('produtos').patchValue(produto.Produtos);
            this.produtoDescontoForm.get('produtosString').patchValue(produto.ProdutosString);
        }
    }

    onChangeNomeProduto(e) {
        if (e.length >= 4) {
            this.auxObservableNomesProdutos = this.usuarioService.getBuscaInicioGruposPromocionais(e.toLowerCase()).subscribe(snap => {
                var dados;
                this.produtos = [];
                let i;
                let sAuxNomeProdutos = '';

                snap.forEach((item, index) => {
                    dados = item.payload.val();
                    sAuxNomeProdutos = '';
                
                    if (dados.NomeBusca.includes(e.toLowerCase()) && dados.Status) {
                        for (i = 0; i < dados.Produtos.length; i++) {
                            sAuxNomeProdutos = sAuxNomeProdutos + dados.Produtos[i].Nome + '; ';
                        }

                        this.produtos.push({
                            ID: item.key,
                            Nome: dados.Nome,
                            Status: dados.Status,
                            QuantidadeMinima: dados.QuantidadeMinima,
                            Produtos: dados.Produtos,
                            ProdutosString: sAuxNomeProdutos
                        });
                    }
                });
            });
        }
    }

    cancelar() {
        this.dialogRef.close();
    }

    omit_special_char(event) {
        var k;
        k = event.charCode;

        if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 44 || k == 47) {
            return true;
        } else {
            this.bCaracterEspecial = true;
            return false;
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.produtoDescontoForm.controls; }

}
